import { ReactElement } from 'react';
import { Route } from 'react-router-dom';

import { defiRoutesConfig } from './defiRoutesConfig';
import { DeFi } from './screens/DeFi';

export function getDeFiRoutes(): ReactElement {
  return (
    <Route
      index
      element={<DeFi />}
      path={defiRoutesConfig.defi.generatePath()}
    />
  );
}
